/* eslint-disable no-undef */
import { call, put, takeEvery } from "redux-saga/effects"

// Login Redux States
import { ADD_BLOCK } from "./actionTypes"
import { apiError, addBlockSuccess } from "./actions"

//Include Both Helper File with needed methods
import { addBlock } from "../../../helpers/backend_helper"

function* add(action) {
  try {
    const response = yield call(addBlock, action.payload.form)
    if (response == undefined) throw new Error("API error")
    if (!response.success) throw new Error("Error al guardar el bloque")
    yield put(addBlockSuccess(response))
  } catch (error) {
    yield put(apiError(error.message))
  }
}

function* blockAddSaga() {
  yield takeEvery(ADD_BLOCK, add)
}

export default blockAddSaga
